import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import httpClient from '@yola/http-client';
import bowser from 'yola-bowser';
import errorModule from 'src/js/modules/error';

const useUrl = (url) => {
  const [htmlContent, setHtmlContent] = useState(null);
  const dispatch = useDispatch();

  useMemo(() => {
    if (!url) return;

    httpClient
      .get(url)
      .then((response) => {
        const baseUrl = url.replace(/\/[^/]+\.html$/, '').replace(/\/$/gi, '');
        let html = response.data.replace('<head>', `<head><base href="${baseUrl}" >`);
        if (bowser.mobile) {
          html = html
            .replace(/\sfullscreen\s/g, ' fullscreen-safe ')
            .replace(/\sfullscreen=/g, ' fullscreen-safe=');
        }
        html = html.replace(
          /<ws-online-store/g,
          '<ws-online-store view-mode="product-browser" lazy-loading="true" '
        );
        setHtmlContent(html);
      })
      .catch((error) => {
        dispatch(errorModule.actions.trackError(error));
        setHtmlContent('404');
      });
  }, [url]);

  return htmlContent;
};

export default useUrl;
